<template>
	<v-dialog v-model="globalModalState" persistent fullscreen>
    <!--<v-dialog v-model="globalModalState" persistent>-->
        <v-card>
          <v-card-title class="modalTitle">
            <span class="mTitle">{{ globalModalTitle }}</span>
            <!--<button type="button" class="btn btn--icon theme--dark" @click="fncHideModal" style="position: relative;"><div class="btn__content"><i aria-hidden="true" class="icon material-icons">close</i></div></button>-->
          </v-card-title>
          <v-container class="pt-3 pb-0 pl-0 pr-0 scrollHolder" style="max-width: 100%">
            <modal-forgot-password v-if="globalModalComponent == 'modal-forgot-password'"></modal-forgot-password>
            <modal-setup v-if="globalModalComponent == 'modal-setup'"></modal-setup>
            <modal-general-settings v-if="globalModalComponent == 'modal-general-settings'"></modal-general-settings>
            <modal-installations v-if="globalModalComponent == 'modal-installations'"></modal-installations>
            <modal-stock v-if="globalModalComponent == 'modal-stock'"></modal-stock>
            <modal-role v-if="globalModalComponent == 'modal-role'"></modal-role>
            <modal-status-add v-if="globalModalComponent == 'modal-status-add'"></modal-status-add>
            <modal-rfc-status-add v-if="globalModalComponent == 'modal-rfc-status-add'"></modal-rfc-status-add>
            <modal-status-edit v-if="globalModalComponent == 'modal-status-edit'"></modal-status-edit>
            <modal-rfc-status-edit v-if="globalModalComponent == 'modal-rfc-status-edit'"></modal-rfc-status-edit>
            <modal-status-import v-if="globalModalComponent == 'modal-status-import'"></modal-status-import>
            <modal-filter-quotes v-if="globalModalComponent == 'modal-filter-quotes'"></modal-filter-quotes>
            <modal-filter-columns v-if="globalModalComponent == 'modal-filter-columns'"></modal-filter-columns>
            <modal-filter-columns-lite v-if="globalModalComponent == 'modal-filter-columns-lite'"></modal-filter-columns-lite>
            <modal-filter-so-columns v-if="globalModalComponent == 'modal-filter-so-columns'"></modal-filter-so-columns>
            <modal-privilege-add v-if="globalModalComponent == 'modal-privilege-add'"></modal-privilege-add>
            <modal-privilege-edit v-if="globalModalComponent == 'modal-privilege-edit'"></modal-privilege-edit>
            <modal-region-add v-if="globalModalComponent == 'modal-region-add'"></modal-region-add>
            <modal-region-edit v-if="globalModalComponent == 'modal-region-edit'"></modal-region-edit>
            <modal-region-children v-if="globalModalComponent == 'modal-region-children'"></modal-region-children>
            <modal-role-add v-if="globalModalComponent == 'modal-role-add'"></modal-role-add>
            <modal-role-edit v-if="globalModalComponent == 'modal-role-edit'"></modal-role-edit>
            <modal-vendor-select v-if="globalModalComponent == 'modal-vendor-select'"></modal-vendor-select>
            <modal-vendor-select-edit v-if="globalModalComponent == 'modal-vendor-select-edit'"></modal-vendor-select-edit>
            <modal-vendor-add v-if="globalModalComponent == 'modal-vendor-add'"></modal-vendor-add>
            <modal-vendor-edit v-if="globalModalComponent == 'modal-vendor-edit'"></modal-vendor-edit>
            <modal-department-add v-if="globalModalComponent == 'modal-department-add'"></modal-department-add>
            <modal-department-edit v-if="globalModalComponent == 'modal-department-edit'"></modal-department-edit>
            <modal-branch-add v-if="globalModalComponent == 'modal-branch-add'"></modal-branch-add>
            <modal-branch-edit v-if="globalModalComponent == 'modal-branch-edit'"></modal-branch-edit>
            <modal-role-plists v-if="globalModalComponent == 'modal-role-plists'"></modal-role-plists>
            <modal-role-privs v-if="globalModalComponent == 'modal-role-privs'"></modal-role-privs>
            <modal-role-status v-if="globalModalComponent == 'modal-role-status'"></modal-role-status>
            <modal-user-info v-if="globalModalComponent == 'modal-user-info'"></modal-user-info>
            <modal-user-regions v-if="globalModalComponent == 'modal-user-regions'"></modal-user-regions>
            <modal-quote-history v-if="globalModalComponent == 'modal-quote-history'"></modal-quote-history>
            <modal-quote-history-order v-if="globalModalComponent == 'modal-quote-history-order'"></modal-quote-history-order>
            <modal-filter-product-sales-reports v-if="globalModalComponent == 'modal-filter-product-sales-reports'"></modal-filter-product-sales-reports>
            <modal-pricelist-add v-if="globalModalComponent == 'modal-pricelist-add'"></modal-pricelist-add>
            <modal-pricelist-add-new v-if="globalModalComponent == 'modal-pricelist-add-new'"></modal-pricelist-add-new>
            <modal-pricelist-edit v-if="globalModalComponent == 'modal-pricelist-edit'"></modal-pricelist-edit>
            <modal-pricelist-clone v-if="globalModalComponent == 'modal-pricelist-clone'"></modal-pricelist-clone>
            <modal-user-settings v-if="globalModalComponent == 'modal-user-settings'"></modal-user-settings>
            <modal-user-import v-if="globalModalComponent == 'modal-user-import'"></modal-user-import>
            <modal-company-import v-if="globalModalComponent == 'modal-company-import'"></modal-company-import>
            <modal-branch-import v-if="globalModalComponent == 'modal-branch-import'"></modal-branch-import>
            <modal-project-add v-if="globalModalComponent == 'modal-project-add'"></modal-project-add>
            <modal-project-edit v-if="globalModalComponent == 'modal-project-edit'"></modal-project-edit>
            <modal-project-quote-details v-if="globalModalComponent == 'modal-project-quote-details'"></modal-project-quote-details>
            <modal-project-status-add v-if="globalModalComponent == 'modal-project-status-add'"></modal-project-status-add>
            <modal-project-status-edit v-if="globalModalComponent == 'modal-project-status-edit'"></modal-project-status-edit>
            <modal-company-create v-if="globalModalComponent == 'modal-company-create'"></modal-company-create>
            <modal-company-update v-if="globalModalComponent == 'modal-company-update'"></modal-company-update>
            <modal-user-create v-if="globalModalComponent == 'modal-user-create'"></modal-user-create>
            <modal-user-edit v-if="globalModalComponent == 'modal-user-edit'"></modal-user-edit>
            <modal-distribute-quote v-if="globalModalComponent == 'modal-distribute-quote'"></modal-distribute-quote>
            <modal-rfc-history v-if="globalModalComponent == 'modal-rfc-history'"></modal-rfc-history>
            <modal-filter-rfc v-if="globalModalComponent == 'modal-filter-rfc'"></modal-filter-rfc>
            <modal-filter-discount v-if="globalModalComponent == 'modal-filter-discount'"></modal-filter-discount>
            <modal-quote-status-update v-if="globalModalComponent == 'modal-quote-status-update'"></modal-quote-status-update>
            <modal-quote-status-report-update v-if="globalModalComponent == 'modal-quote-status-report-update'"></modal-quote-status-report-update>
            <modal-product-sales-products v-if="globalModalComponent == 'modal-product-sales-products'"></modal-product-sales-products>
            <modal-quote-details v-if="globalModalComponent == 'modal-quote-details'"></modal-quote-details>
            <modal-edit-quote-details v-if="globalModalComponent == 'modal-edit-quote-details'"></modal-edit-quote-details>
            <modal-sales-order-report-details v-if="globalModalComponent == 'modal-sales-order-report-details'"></modal-sales-order-report-details>
            <modal-factory-add v-if="globalModalComponent == 'modal-factory-add'"></modal-factory-add>
            <modal-factory-edit v-if="globalModalComponent == 'modal-factory-edit'"></modal-factory-edit>
            <modal-edit-radius v-if="globalModalComponent == 'modal-edit-radius'"></modal-edit-radius>
            <modal-package-add v-if="globalModalComponent == 'modal-package-add'"></modal-package-add>
            <modal-package-edit v-if="globalModalComponent == 'modal-package-edit'"></modal-package-edit>
            <modal-vehicle-add v-if="globalModalComponent == 'modal-vehicle-add'"></modal-vehicle-add>
            <modal-vehicle-edit v-if="globalModalComponent == 'modal-vehicle-edit'"></modal-vehicle-edit>
            <modal-user-notifications v-if="globalModalComponent == 'modal-user-notifications'"></modal-user-notifications>
            <modal-user-password v-if="globalModalComponent == 'modal-user-password'"></modal-user-password>
            <modal-user-pricelists v-if="globalModalComponent == 'modal-user-pricelists'"></modal-user-pricelists>
            <modal-user-status v-if="globalModalComponent == 'modal-user-status'"></modal-user-status>
            <modal-user-company v-if="globalModalComponent == 'modal-user-company'"></modal-user-company>
            <modal-user-company-details v-if="globalModalComponent == 'modal-user-company-details'"></modal-user-company-details>
            <modal-user-details v-if="globalModalComponent == 'modal-user-details'"></modal-user-details>
            <modal-doc-override v-if="globalModalComponent == 'modal-doc-override'"></modal-doc-override>
            <modal-user-link v-if="globalModalComponent == 'modal-user-link'"></modal-user-link>
            <modal-quote-settings v-if="globalModalComponent == 'modal-quote-settings'"></modal-quote-settings>
            <modal-so-settings v-if="globalModalComponent == 'modal-so-settings'"></modal-so-settings>
            <modal-quote-link-users v-if="globalModalComponent == 'modal-quote-link-users'"></modal-quote-link-users>
            <modal-quote-forex v-if="globalModalComponent == 'modal-quote-forex'"></modal-quote-forex>
            <modal-tier-add v-if="globalModalComponent == 'modal-tier-add'"></modal-tier-add>
            <modal-tier-edit v-if="globalModalComponent == 'modal-tier-edit'"></modal-tier-edit>
            <modal-base-price v-if="globalModalComponent == 'modal-base-price'"></modal-base-price>
            <modal-set-notifications v-if="globalModalComponent == 'modal-set-notifications'"></modal-set-notifications>
            <modal-token-add v-if="globalModalComponent == 'modal-token-add'"></modal-token-add>
            <modal-token-edit v-if="globalModalComponent == 'modal-token-edit'"></modal-token-edit>
            <modal-survey-document v-if="globalModalComponent == 'modal-survey-document'"></modal-survey-document>
            <modal-process-add v-if="globalModalComponent == 'modal-process-add'"></modal-process-add>
            <modal-process-edit v-if="globalModalComponent == 'modal-process-edit'"></modal-process-edit>
            <modal-set-so-number v-if="globalModalComponent == 'modal-set-so-number'"></modal-set-so-number>
            <modal-notification-history v-if="globalModalComponent == 'modal-notification-history'"></modal-notification-history>
            <modal-set-reps v-if="globalModalComponent == 'modal-set-reps'"></modal-set-reps>
            <modal-set-so-reps v-if="globalModalComponent == 'modal-set-so-reps'"></modal-set-so-reps>
            <modal-set-kams v-if="globalModalComponent == 'modal-set-kams'"></modal-set-kams>
            <modal-set-originators v-if="globalModalComponent == 'modal-set-originators'"></modal-set-originators>
            <modal-summary-reporting v-if="globalModalComponent == 'modal-summary-reporting'"></modal-summary-reporting>
            <modal-quote-calculator v-if="globalModalComponent == 'modal-quote-calculator'"></modal-quote-calculator>
            <modal-vendor-users v-if="globalModalComponent == 'modal-vendor-users'"></modal-vendor-users>
            <modal-set-emails v-if="globalModalComponent == 'modal-set-emails'"></modal-set-emails>
            <modal-clone-quote v-if="globalModalComponent == 'modal-clone-quote'"></modal-clone-quote>
            <modal-create-lead v-if="globalModalComponent == 'modal-create-new-lead'"></modal-create-lead>
            <modal-quote-totals v-if="globalModalComponent == 'modal-quote-totals'"></modal-quote-totals>
            <modal-generate-link v-if="globalModalComponent == 'modal-generate-link'"></modal-generate-link>
            <modal-store-audit v-if="globalModalComponent == 'modal-store-audit'"></modal-store-audit>
            <modal-archived-quotes v-if="globalModalComponent == 'modal-archived-quotes'"></modal-archived-quotes>
            <modal-update-store v-if="globalModalComponent == 'modal-update-store'"></modal-update-store>
            <modal-api-history v-if="globalModalComponent == 'modal-api-history'"></modal-api-history>
            <modal-quote-api-dates v-if="globalModalComponent == 'modal-quote-api-dates'"></modal-quote-api-dates>
            <modal-quote-api-dates v-if="globalModalComponent == 'modal-quote-api-dates'"></modal-quote-api-dates>
            <modal-date-history v-if="globalModalComponent == 'modal-date-history'"></modal-date-history>
            <modal-quote-full v-if="globalModalComponent == 'modal-quote-full'"></modal-quote-full>
            <modal-quote-status-update-lite v-if="globalModalComponent == 'modal-quote-status-update-lite'"></modal-quote-status-update-lite>
            <modal-set-reps-lite v-if="globalModalComponent == 'modal-set-reps-lite'"></modal-set-reps-lite>
          </v-container>
        </v-card>
      </v-dialog>
</template>

<script>

import modalForgotPassword from '../authentication/ForgotPassword';
import modalSetup from './Setup';
import modalGeneralSettings from './Settings';
import modalInstallations from './Installations';
import modalStock from './Stock';
import modalRole from '../roles/modals/Role.vue';
import modalStatusAdd from '../reports/modals/Modal_Status_Add';
import modalRfcStatusAdd from '../reports/modals/Modal_Rfc_Status_Add';
import modalStatusEdit from '../reports/modals/Modal_Status_Edit';
import modalRfcStatusEdit from '../reports/modals/Modal_Rfc_Status_Edit';
import modalStatusImport from '../reports/modals/Modal_Status_Import';
import modalFilterQuotes from '../reports/modals/Modal_Filter_Quotes';
import modalFilterColumns from '../reports/modals/Modal_Filter_Columns';
import modalFilterColumnsLite from '../reports/modals/Modal_Filter_Columns_Lite';
import modalFilterSoColumns from '../reports/modals/Modal_Filter_SO_Columns';
import modalQuoteHistory from '../reports/modals/Modal_Quote_History';
import modalQuoteHistoryOrder from '../reports/modals/Modal_Quote_History_Order';
import modalPrivilegeAdd from '../privileges/modals/Modal_Privilege_Add';
import modalPrivilegeEdit from '../privileges/modals/Modal_Privilege_Edit';
import modalRegionAdd from '../regions/modals/Modal_Region_Add';
import modalRegionEdit from '../regions/modals/Modal_Region_Edit';
import modalRegionChildren from '../regions/modals/Modal_Region_Children';
import modalRoleAdd from '../roles/modals/Modal_Role_Add';
import modalRoleEdit from '../roles/modals/Modal_Role_Edit';
import modalVendorSelect from '../vendors/modals/Modal_Vendor_Select';
import modalVendorSelectEdit from '../vendors/modals/Modal_Vendor_Select_Edit';
import modalVendorAdd from '../vendors/modals/Modal_Vendor_Add';
import modalVendorEdit from '../vendors/modals/Modal_Vendor_Edit';
import modalDepartmentAdd from '../departments/modals/Modal_Department_Add';
import modalDepartmentEdit from '../departments/modals/Modal_Department_Edit';
import modalBranchAdd from '../branches/modals/Modal_Branch_Add';
import modalBranchEdit from '../branches/modals/Modal_Branch_Edit';
import modalRolePlists from '../roles/modals/Modal_Role_Plists';
import modalRolePrivs from '../roles/modals/Modal_Role_Privs';
import modalRoleStatus from '../roles/modals/Modal_Role_Status';
import modalUserInfo from '../reports/modals/Modal_User_Info';
import modalUserRegions from '../reports/modals/Modal_User_Regions';
import modalFilterProductSalesReports from '../reports/modals/Modal_Filter_Product_Sales_Reports';
import modalPricelistAdd from '../pricelists/modals/Modal_Pricelist_Add';
import modalPricelistAddNew from '../pricelists/modals/Modal_Pricelist_Add_New';
import modalPricelistEdit from '../pricelists/modals/Modal_Pricelist_Edit';
import modalPricelistClone from '../pricelists/modals/Modal_Pricelist_Clone';
import modalUserSettings from '../users/modals/User_Settings';
import modalUserImport from '../users/modals/Modal_User_Import';
import modalCompanyImport from '../users/modals/Modal_Company_Import';
import modalBranchImport from '../users/modals/Modal_Branch_Import';
import modalProjectAdd from '../projects/modals/Modal_Project_Add';
import modalProjectEdit from '../projects/modals/Modal_Project_Edit';
import modalProjectQuoteDetails from '../projects/modals/Modal_Project_Quote_Details';
import modalProjectStatusAdd from '../projects/modals/Modal_Project_Status_Add';
import modalProjectStatusEdit from '../projects/modals/Modal_Project_Status_Edit';
import modalCompanyCreate from '../users/modals/Modal_Company_Create';
import modalCompanyUpdate from '../users/modals/Modal_Company_Update';
import modalUserCreate from '../users/modals/Modal_User_Create';
import modalUserEdit from '../users/modals/Modal_User_Edit';
import modalDistributeQuote from '../reports/modals/Modal_Distribute_Quote';
import modalCloneQuote from '../reports/modals/Modal_clone_quote';
import modalRfcHistory from '../reports/modals/Modal_Rfc_History';
import modalFilterRfc from '../reports/modals/Modal_Filter_Rfc';
import modalQuoteStatusUpdate from '../reports/modals/Modal_Quote_Status_Update';
import modalQuoteStatusReportUpdate from '../reports/modals/Modal_Quote_Status_Report_Update';
import modalFilterDiscount from '../reports/modals/Modal_Filter_Discount';
import modalProductSalesProducts from '../reports/modals/Modal_Product_Sales_Products';
import modalQuoteDetails from '../reports/modals/Modal_Quote_Details';
import modalEditQuoteDetails from '../reports/modals/Modal_Edit_Quote_Details';
import modalSalesOrderReportDetails from '../reports/modals/Modal_Sales_Order_Report_Details';
import modalFactoryAdd from '../transport/factories/modals/Modal_Factory_Add';
import modalFactoryEdit from '../transport/factories/modals/Modal_Factory_Edit';
import modalEditRadius from '../transport/cost-matrix/modals/Modal_Edit_Radius';
import modalPackageAdd from '../transport/packages/modals/Modal_Package_Add';
import modalPackageEdit from '../transport/packages/modals/Modal_Package_Edit';
import modalVehicleAdd from '../transport/vehicles/modals/Modal_Vehicle_Add';
import modalVehicleEdit from '../transport/vehicles/modals/Modal_Vehicle_Edit';
import modalUserNotifications from '../users/modals/Modal_User_Notifications';
import modalUserPassword from '../users/modals/Modal_User_Password';
import modalUserPricelists from '../users/modals/Modal_User_Pricelists';
import modalUserStatus from '../users/modals/Modal_User_Status';
import modalUserCompany from '../users/modals/Modal_User_Company';
import modalUserCompanyDetails from '../users/modals/Modal_User_Company_Details';
import modalUserDetails from '../users/modals/Modal_User_Details';
import modalDocOverride from '../users/modals/Modal_Doc_Override';
import modalUserLink from '../users/modals/Modal_User_Link';
import modalQuoteSettings from '../reports/modals/Modal_Quote_Settings';
import modalSoSettings from '../reports/modals/Modal_SO_Settings';
import modalQuoteLinkUsers from '../reports/modals/Modal_Quote_Link_Users';
import modalQuoteForex from '../reports/modals/Modal_Quote_Forex';
import modalTierAdd from '../installation_cost/modals/Modal_Tier_Add';
import modalTierEdit from '../installation_cost/modals/Modal_Tier_Edit';
import modalBasePrice from '../installation_cost/modals/Modal_Base_Price';
import modalSetNotifications from '../notifications/modals/Modal_Set_Notifications';
import modalTokenAdd from '../tokens/modals/Modal_Token_Add';
import modalTokenEdit from '../tokens/modals/Modal_Token_Edit';
import modalSetSoNumber from '../reports/modals/Modal_Set_So_Number';
import modalSurveyDocument from '../reports/modals/Modal_Survey_Document';
import modalProcessAdd from '../process/modals/Modal_Process_Add';
import modalProcessEdit from '../process/modals/Modal_Process_Edit';
import modalNotificationHistory from '../reports/modals/Modal_Notification_History';
import modalSetReps from '../reports/modals/Modal_Set_Reps';
import modalSetSoReps from '../reports/modals/Modal_Set_SO_Reps';
import modalSetKams from '../reports/modals/Modal_Set_Kams';
import modalSetOriginators from '../reports/modals/Modal_Set_Originators';
import modalSummaryReporting from '../reports/modals/Modal_Summary_Reporting';
import modalQuoteCalculator from '../reports/modals/Modal_Quote_Calculator';
import modalVendorUsers from '../reports/modals/Modal_Vendor_Users';
import modalSetEmails from '../reports/modals/Modal_Set_Emails';
import modalCreateLead from '../reports/modals/Modal_create_new_lead';
import modalQuoteTotals from '../reports/modals/Modal_quote_totals';
import modalGenerateLink from '../process/modals/Modal_Generate_Link';
import modalStoreAudit from '../reports/modals/Modal_Store_Audit';
import modalArchivedQuotes from '../reports/modals/Modal_Archived_Quotes';
import modalUpdateStore from '../reports/modals/Modal_Update_Store';
import modalApiHistory from '../reports/modals/Modal_Api_History';
import modalQuoteApiDates from '../reports/modals/Modal_Quote_api_dates';
import ModalDateHistory from "../reports/modals/Modal_Date_History";
import modalQuoteFull from '../reports/modals/Modal_Quote_Full';
import modalQuoteStatusUpdateLite from '../reports/modals/Modal_Quote_Status_Update_Lite';
import modalSetRepsLite from '../reports/modals/Modal_Set_Reps_Lite';

import { mapGetters } from 'vuex';


export default{
	data () {
		return {
			importPath: 'e',
			dynamicComponent: 'globalModalComponent'
		};
	},
	methods: {
		fncHideModal() {
			this.$store.commit('hideModal')
		}
	},
	computed: {
		...mapGetters([
			'globalModalTitle',
			'globalModalComponent',
			'globalModalState'
		])
	},
	props: ['modalProps'],
	components: {
    modalQuoteTotals,
    modalCreateLead,
		modalForgotPassword,
		modalGeneralSettings,
		modalInstallations,
		modalSetup,
        modalStock,
		modalRole,
		modalStatusAdd,
        modalRfcStatusAdd,
		modalStatusEdit,
		modalRfcStatusEdit,
		modalStatusImport,
        modalFilterQuotes,
        modalFilterColumns,
        modalFilterColumnsLite,
        modalFilterSoColumns,
		modalPrivilegeAdd,
		modalPrivilegeEdit,
		modalRegionAdd,
		modalRegionEdit,
		modalRegionChildren,
		modalRoleAdd,
        modalRoleEdit,
        modalVendorSelect,
        modalVendorSelectEdit,
        modalVendorAdd,
        modalVendorEdit,
        modalDepartmentAdd,
        modalDepartmentEdit,
        modalBranchAdd,
        modalBranchEdit,
		modalRolePlists,
		modalRolePrivs,
		modalRoleStatus,
        modalUserInfo,
        modalUserRegions,
        modalQuoteHistory,
        modalQuoteHistoryOrder,
		modalFilterProductSalesReports,
		modalPricelistAdd,
        modalPricelistAddNew,
		modalPricelistEdit,
		modalPricelistClone,
		modalUserSettings,
		modalUserImport,
		modalCompanyImport,
		modalBranchImport,
        modalProjectAdd,
        modalProjectEdit,
        modalProjectQuoteDetails,
		modalProjectStatusAdd,
		modalProjectStatusEdit,
        modalCompanyCreate,
        modalCompanyUpdate,
        modalUserCreate,
        modalUserEdit,
        modalDistributeQuote,
        modalCloneQuote,
        modalRfcHistory,
        modalFilterRfc,
        modalQuoteStatusUpdate,
        modalQuoteStatusReportUpdate,
        modalFilterDiscount,
        modalProductSalesProducts,
        modalQuoteDetails,
        modalEditQuoteDetails,
        modalSalesOrderReportDetails,
        modalFactoryAdd,
        modalFactoryEdit,
        modalEditRadius,
        modalPackageAdd,
        modalPackageEdit,
        modalVehicleAdd,
        modalVehicleEdit,
        modalUserNotifications,
        modalUserPassword,
        modalUserPricelists,
        modalUserStatus,
        modalUserCompany,
        modalUserCompanyDetails,
        modalUserDetails,
        modalDocOverride,
        modalUserLink,
        modalQuoteSettings,
        modalSoSettings,
        modalQuoteLinkUsers,
        modalQuoteForex,
        modalTierAdd,
        modalTierEdit,
        modalBasePrice,
        modalSetNotifications,
        modalTokenAdd,
        modalTokenEdit,
        modalSetSoNumber,
        modalSurveyDocument,
        modalProcessAdd,
        modalProcessEdit,
        modalNotificationHistory,
    modalSetReps,
    modalSetSoReps,
    modalSetKams,
    modalSetOriginators,
        modalSummaryReporting,
    modalQuoteCalculator,
    modalVendorUsers,
    modalSetEmails,
    modalStoreAudit,
    modalGenerateLink,
    modalStoreAudit,
    modalArchivedQuotes,
    modalUpdateStore,
    modalApiHistory,
    modalQuoteApiDates,
    ModalDateHistory,
    modalQuoteFull,
    modalQuoteStatusUpdateLite,
    modalSetRepsLite
	}
};

</script>

<style scoped>
	@import './assets/css/shared.css';
</style>
